import gql from 'graphql-tag';

// ***
// TO BE MOVED TO OTHER DIRECTORY - DELETE THIS DIRECTORY
// ***
export const _GET_ALL_WORKLIST_ITEMS = gql`
	query gqlActionsGrouped_getAllWorklistItems(
		$searchTerm: String
		$isDueDate: Boolean!
		$isStartTime: Boolean!
		$isChannel: Boolean!
		$isRecipient: Boolean!
		$isMessageCode: Boolean!
		$isReference: Boolean!
		$isAssignee: Boolean!
		$limit: Int!
		$offset: Int!
		$orderBy: [risolto_virtual_action_group_order_by!]
		$statuses: _text
		$participants: _uuid
		$startTimeFrom:timestamp
  		$startTimeUntil:timestamp
	) {
		total: risolto_action_group_v10_aggregate(
			args: {
				search_term: $searchTerm
				group_reference: $isReference
				group_due_date: $isDueDate
				group_start_time: $isStartTime
				group_channel: $isChannel
				group_recipient: $isRecipient
				group_message_code: $isMessageCode
				group_assignee: $isAssignee
				statuses: $statuses
				participants: $participants
				start_time_from:$startTimeFrom, 
				start_time_until:$startTimeUntil
			}
		) {
			aggregate {
				count
			}
		}
		actions: risolto_action_group_v10(
			args: {
				search_term: $searchTerm
				group_due_date: $isDueDate
				group_start_time: $isStartTime
				group_channel: $isChannel
				group_recipient: $isRecipient
				group_message_code: $isMessageCode
				group_assignee: $isAssignee
				group_reference: $isReference
				statuses: $statuses
				participants: $participants
				start_time_from:$startTimeFrom, 
				start_time_until:$startTimeUntil
			}
			limit: $limit
			offset: $offset
			order_by: $orderBy
		) {
			v_reference
			reference
			action_by_reference {
				source
				channel_endpoint
				channel_endpoint_by_reference {
					channel
					endpoint
					endpoint_details
					deactivated_at
					deactivated_by
					last_failed_delivery_at
					last_failed_delivery_type
					locale
					priority
				}
				status
				original_action
				retry_count
				participant
				metadata
				action_invoices(order_by: { invoice_by_reference: { issue_date: desc_nulls_last } }) {
					relation
					invoice
					invoice_by_reference {
						invoice_number
						open_amount
						total_amount
						payment_reference
						due_date
						issue_date
						status
						recipient
						recipient_by_reference {
							reference
							name
						}
						legal_entity
						legal_entity_by_reference {
							reference
							registration_name
						}
						participant
						participant_by_reference {
							name
							reference
							logical_id
						}
						reference
						amount_currency
						interchange_links {
							interchange_by_reference {
								reference
								channel
								direction
							}
						}
					}
				}
				status
				reference
				execution_type
				recipient
				recipient_by_reference {
					reference
					name
					account_id
					participant
				}
				legal_entity_by_reference {
					reference
					registration_name
					outbound_channel: processing_details(path: "outbound_channel")
				}
				message_code
				channel
				due_date
				start_time
				assignee
				assignee_by_reference {
					reference
					username
				}
				legal_entity
				legal_entity_by_reference {
					reference
					registration_name
					company_id
					company_id_type
				}
			}
			action_count
			due_date
			due_date_count
			channel
			channel_count
			recipient
			recipient_by_reference {
				name
				reference
				type
				participant
				legal_id_type
				legal_id
				legal_entity
				account_id
				contacts {
					reference
					first_name
					last_name
				}
				invoice_documents_aggregate {
					aggregate {
						sum {
							open_amount
							total_amount
						}
					}
				}
			}
			recipient_count
			assignee_by_reference {
				username
			}
			start_time
			start_time_count
			assignee_count
			message_code
			message_code_count
		}
	}
`;
export const _GET_UNASSIGNED_WORKLIST_ITEMS = gql`
	query gqlActionsGrouped_getunassignedWorklistItems(
		$searchTerm: String
		$isDueDate: Boolean!
		$isStartTime: Boolean!
		$isChannel: Boolean!
		$isRecipient: Boolean!
		$isMessageCode: Boolean!
		$isAssignee: Boolean!
		$isReference: Boolean!
		$limit: Int!
		$offset: Int!
		$orderBy: [risolto_virtual_action_group_order_by!]
		$statuses: _text
		$participants: _uuid
		$startTimeFrom:timestamp
  		$startTimeUntil:timestamp
	) {
		total: risolto_action_group_v10_aggregate(
			args: {
				search_term: $searchTerm
				group_reference: $isReference
				group_due_date: $isDueDate
				group_start_time: $isStartTime
				group_channel: $isChannel
				group_recipient: $isRecipient
				group_message_code: $isMessageCode
				group_assignee: $isAssignee
				statuses: $statuses
				participants: $participants
				start_time_from:$startTimeFrom, 
				start_time_until:$startTimeUntil
			}
		) {
			aggregate {
				count
			}
		}
		actions: risolto_action_group_v10(
			where: {
				assignee: { _is_null: true }
			},
			args: {
				search_term: $searchTerm
				group_due_date: $isDueDate
				group_start_time: $isStartTime
				group_channel: $isChannel
				group_recipient: $isRecipient
				group_message_code: $isMessageCode
				group_assignee: $isAssignee
				group_reference: $isReference
				statuses: $statuses
				participants: $participants
				start_time_from:$startTimeFrom, 
				start_time_until:$startTimeUntil
			}
			limit: $limit
			offset: $offset
			order_by: $orderBy
		) {
			v_reference
			reference
			action_by_reference {
				source
				channel_endpoint
				channel_endpoint_by_reference {
					channel
					endpoint
					endpoint_details
					deactivated_at
					deactivated_by
					last_failed_delivery_at
					last_failed_delivery_type
					locale
					priority
				}
				status
				original_action
				retry_count
				participant
				metadata
				action_invoices(order_by: { invoice_by_reference: { issue_date: desc_nulls_last } }) {
					relation
					invoice
					invoice_by_reference {
						invoice_number
						open_amount
						total_amount
						payment_reference
						due_date
						issue_date
						status
						recipient
						recipient_by_reference {
							reference
							name
						}
						legal_entity
						legal_entity_by_reference {
							reference
							registration_name
						}
						participant
						participant_by_reference {
							name
							reference
							logical_id
						}
						reference
						amount_currency
						interchange_links {
							interchange_by_reference {
								reference
								channel
								direction
							}
						}
					}
				}
				status
				reference
				execution_type
				recipient
				recipient_by_reference {
					reference
					name
					account_id
					participant
				}
				legal_entity_by_reference {
					reference
					registration_name
					outbound_channel: processing_details(path: "outbound_channel")
				}
				message_code
				channel
				due_date
				start_time
				assignee
				assignee_by_reference {
					reference
					username
				}
				legal_entity
				legal_entity_by_reference {
					reference
					registration_name
					company_id
					company_id_type
				}
			}
			action_count
			due_date
			due_date_count
			channel
			channel_count
			recipient
			recipient_by_reference {
				name
				reference
				type
				participant
				legal_id_type
				legal_id
				legal_entity
				account_id
				contacts {
					reference
					first_name
					last_name
				}
				invoice_documents_aggregate {
					aggregate {
						sum {
							open_amount
							total_amount
						}
					}
				}
			}
			recipient_count
			assignee_by_reference {
				username
			}
			start_time
			start_time_count
			assignee_count
			message_code
			message_code_count
		}
	}
`;
export const _GET_ASSIGNED_WORKLIST_ITEMS = gql`
	query gqlActionsGrouped_getAssignedWorklistItems(
		$searchTerm: String
		$isDueDate: Boolean!
		$isStartTime: Boolean!
		$isChannel: Boolean!
		$isRecipient: Boolean!
		$isMessageCode: Boolean!
		$isReference: Boolean!
		$isAssignee: Boolean!
		$limit: Int!
		$offset: Int!
		$orderBy: [risolto_virtual_action_group_order_by!]
		$statuses: _text
		$assignee: uuid!
		$participants: _uuid
		$startTimeFrom:timestamp
  		$startTimeUntil:timestamp
	) {
		total: risolto_action_group_v10_aggregate(
			args: {
				search_term: $searchTerm
				group_reference: $isReference
				group_due_date: $isDueDate
				group_start_time: $isStartTime
				group_channel: $isChannel
				group_recipient: $isRecipient
				group_message_code: $isMessageCode
				group_assignee: $isAssignee
				statuses: $statuses
				participants: $participants
				start_time_from:$startTimeFrom, 
				start_time_until:$startTimeUntil
			}
		) {
			aggregate {
				count
			}
		}
		actions: risolto_action_group_v10(
			where: {
				assignee: { _eq: $assignee }
			},
			args: {
				search_term: $searchTerm
				group_due_date: $isDueDate
				group_start_time: $isStartTime
				group_channel: $isChannel
				group_recipient: $isRecipient
				group_message_code: $isMessageCode
				group_assignee: $isAssignee
				group_reference: $isReference
				statuses: $statuses
				participants: $participants
				start_time_from:$startTimeFrom, 
				start_time_until:$startTimeUntil
			}
			limit: $limit
			offset: $offset
			order_by: $orderBy
		) {
			v_reference
			reference
			action_by_reference {
				source
				channel_endpoint
				channel_endpoint_by_reference {
					channel
					endpoint
					endpoint_details
					deactivated_at
					deactivated_by
					last_failed_delivery_at
					last_failed_delivery_type
					locale
					priority
				}
				status
				original_action
				retry_count
				participant
				metadata
				action_invoices(order_by: { invoice_by_reference: { issue_date: desc_nulls_last } }) {
					relation
					invoice
					invoice_by_reference {
						invoice_number
						open_amount
						total_amount
						payment_reference
						due_date
						issue_date
						status
						recipient
						recipient_by_reference {
							reference
							name
						}
						legal_entity
						legal_entity_by_reference {
							reference
							registration_name
						}
						participant
						participant_by_reference {
							name
							reference
							logical_id
						}
						reference
						amount_currency
						interchange_links {
							interchange_by_reference {
								reference
								channel
								direction
							}
						}
					}
				}
				status
				reference
				execution_type
				recipient
				recipient_by_reference {
					reference
					name
					account_id
					participant
				}
				legal_entity_by_reference {
					reference
					registration_name
					outbound_channel: processing_details(path: "outbound_channel")
				}
				message_code
				channel
				due_date
				start_time
				assignee
				assignee_by_reference {
					reference
					username
				}
				legal_entity
				legal_entity_by_reference {
					reference
					registration_name
					company_id
					company_id_type
				}
			}
			action_count
			due_date
			due_date_count
			channel
			channel_count
			recipient
			recipient_by_reference {
				name
				reference
				type
				participant
				legal_id_type
				legal_id
				legal_entity
				account_id
				contacts {
					reference
					first_name
					last_name
				}
				invoice_documents_aggregate {
					aggregate {
						sum {
							open_amount
							total_amount
						}
					}
				}
			}
			recipient_count
			assignee_by_reference {
				username
			}
			start_time
			start_time_count
			assignee_count
			message_code
			message_code_count
		}
	}
`;
